// extracted by mini-css-extract-plugin
export default {"container":"competition-layout_container","logo":"competition-layout_logo"};